import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import {
  DownloadedFilesStatistics,
  NetworkClassification
} from "../../../@types/common";

export const DOWNLOADED_FILES_URL_PARAM = "files-classification";

const convertClassificationParamToClassification = (
  classificationParam: string | null
) => {
  if (!classificationParam) return undefined;
  return classificationParam as NetworkClassification;
};

const useDownloadedFilesClassification = (
  statistics?: DownloadedFilesStatistics
) => {
  const [searchParams] = useSearchParams();
  const classificationParam = convertClassificationParamToClassification(
    searchParams.get(DOWNLOADED_FILES_URL_PARAM)
  );
  const defaultClassification =
    classificationParam ??
    ((statistics?.malicious ?? 0) > 0 ? "malicious" : undefined);

  const [classification, setClassification] = useState<
    NetworkClassification | undefined
  >(defaultClassification);

  return {
    classification,
    setClassification
  };
};

export default useDownloadedFilesClassification;
